<template>
  <div class="lead-banner">
    <div class="banner-content">
      <!-- 텍스트 영역 -->

      <div class="banner-text-container">
        <div class="banner-text">
          <p class="subtitle">
            이미 <span class="highlight">2만 명의 사장님</span>이 맞춤형 마케팅 전략을 제안 받았어요.
          </p>
          <p class="title">매출 올리는 방법,<br />무료 상담에서 확인하세요!</p>
        </div>
        <button type="button" class="cta-button" @click="handleClick">
          <span>무료 상담하기</span>
        </button>
      </div>

      <!-- 이미지 영역 -->
      <div class="banner-image">
        <img src="@/assets/img/landing/headset-logo.png" alt="무료 상담" class="headset-icon" />
      </div>
    </div>

    <!-- 도입문의 모달 -->
    <LeadModal :showModal.sync="showLeadModal" sourceRoute="storeLanding" />
  </div>
</template>

<script>
import { pushDataLayer } from '@/utils';
import LeadModal from '@/components/lead/modal/LeadModal.vue';

export default {
  name: 'LeadBanner',
  components: {
    LeadModal,
  },
  data() {
    return {
      showLeadModal: false,
      hasProcessedQuery: false, // 쿼리 파라미터 중복 처리 방지
    };
  },
  mounted() {
    // LeadBanner는 쿼리 파라미터 처리 안 함 (Landing.vue에서 처리)
  },
  methods: {
    handleClick() {
      this.showLeadModal = true;

      pushDataLayer({
        event: 'clickLeadBanner',
        page: 'storeLanding',
        objectType: 'button',
        objectSection: 'leadBanner',
        objectId: 'consultButton',
        objectName: '무료 상담하기',
      });
    },
  },
};
</script>

<style scoped lang="scss">
/* 배너 전체 */
.lead-banner {
  width: 100%;
  background-color: rgba(218, 218, 255, 0.5);
  position: relative;
  overflow: hidden;
}

/* 배너 콘텐츠 */
.banner-content {
  margin: 0 auto;
  max-width: 1156px;
  padding: 0 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 60px;
  height: 250px;
  position: relative;
}

.banner-text-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  position: relative;
  z-index: 1;

  .cta-button {
    display: flex;
    width: 146px;
    padding: 16px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    border: 0 solid var(--default, #3a3a3a);
    background: var(--default, #3a3a3a);
  }
}

/* 텍스트 영역 */
.banner-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;

  .subtitle {
    color: var(--default, #3a3a3a);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .highlight {
    color: var(--Tertiary_light, #0c8aff);
    font-family: 'Spoqa Han Sans Neo';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }

  .title {
    color: var(--default, #3a3a3a);
    font-feature-settings: 'liga' off, 'clig' off;

    font-family: 'Spoqa Han Sans Neo';
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;
  }
}

/* 이미지 영역 */
.banner-image {
  position: absolute;
  right: -86px;
  bottom: -269.5px;
  transform: translateY(-50%);
  height: 400px;
  display: flex;
  align-items: center;
  z-index: 0;

  .headset-icon {
    height: 711px;
    width: auto;
    object-fit: contain;
  }
}

/* 모바일 스타일 */
@media (max-width: 960px) {
  .lead-banner {
    background: linear-gradient(90deg, #ddddff 0%, #f3f3ff 48.6%, #ededff 89.27%);
  }

  .banner-content {
    padding: 24px;
    height: auto;
    position: relative;
  }

  .banner-text {
    width: auto;
    height: auto;

    .subtitle {
      font-size: 12px;
      line-height: 18px;
    }
    .highlight {
      font-size: 12px;
      line-height: 18px;
    }

    .title {
      font-size: 20px;
      line-height: 28px;
    }

    .cta-button {
      width: auto;
      height: auto;
      padding: 12px 16px;
      font-size: 14px;
    }
  }

  .banner-image {
    position: absolute;
    top: auto;
    transform: none;
    right: -80px;
    bottom: -90px;
    height: 300px;

    .headset-icon {
      height: 100%;
    }
  }
}
</style>
